import SafetyMeasureList from './SafetyMeasureList';

export default SafetyMeasureList;
